import React, { useContext, useState } from 'react'
import { Handle } from 'react-flow-renderer';
import { NodesContext } from '../provider/IvrContext';
import WebhookSelectModal from '../Helpers/WebhookSelectModal';
import { toast } from 'react-toastify';

const HangupNode = ({ data, id }) => {
    const { onRemove, webhookList, smsWebhookList, updateNodeData } = useContext(NodesContext)
    const [webhookModalOpen, setWebhookModalOpen] = useState(false);
    const webhookConfig = data?.webhookConfig || null;

    const saveWebhookConfig = (cfg) => {
        updateNodeData(id, { webhookConfig: cfg });
        toast.success(cfg ? "Webhook saved." : "Webhook cleared.");
    };

    return (
        <div
            className="ivr-flow-node"
            style={{
                width: "80px",
                border: "2px solid red",
                borderRadius: "50%",
                background: "#fff",
                position: "relative",
                display: "flex",
                padding: "5px",
                flexDirection: "column",
                alignItems: "center",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                transition: "0.3s ease-in-out",
            }}
        >
            <Handle
                type="target"
                position="top"
                id="new-target-handle-hangup"
                style={{
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "red",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                }}
            />

            <span
                className="ivr-flow-node-label"
                style={{
                    fontSize: "9px",
                    fontWeight: "bold",
                    color: "#333",
                    textAlign: "center",
                    textTransform: "capitalize",
                }}
            >
                {data.label}
            </span>

            {/* Icons Row */}
            <div style={{ display: "flex", gap: "8px" }}>
                <i
                    className="fa fa-link ivr-flow-node-icon"
                    style={{ color: webhookConfig ? "red" : "#888", fontSize: "12px", cursor: "pointer" }}
                    title="Webhook"
                    onClick={() => setWebhookModalOpen(true)}
                />
                <i
                    className="fa fa-trash ivr-flow-node-icon"
                    style={{ color: "red", fontSize: "12px", cursor: "pointer" }}
                    title="Remove"
                    onClick={() => onRemove(id)}
                />
            </div>

            <WebhookSelectModal
                show={webhookModalOpen}
                onClose={() => setWebhookModalOpen(false)}
                value={webhookConfig}
                onSave={saveWebhookConfig}
                webhookList={webhookList}
                smsWebhookList={smsWebhookList}
                title="Hangup Node Webhook"
            />
        </div>
    );
}

export default HangupNode
